import React from "react";
import {Templates, useTemplate} from "@/util-react/template.tsx";
import {BrowseCategoriesDefault} from "@/elements-react/browse-categories/templates/browse-categories.default.tsx";
import {
    BrowseCategoriesBlackAndBlue
} from "@/elements-react/browse-categories/templates/browse-categories.black-and-blue.tsx";

export interface CategoryItem {
    id: string;
    name: string;
    url: string;
}

export interface BrowseCategoriesProps {
    categories: CategoryItem[];
    className?: string;
    title?: string;
    subtitle?: string;
}

const templates: Record<Templates, React.ComponentType<BrowseCategoriesProps>> = {
    [Templates.DEFAULT]: BrowseCategoriesDefault,
    [Templates.BLACK_AND_BLUE]:  BrowseCategoriesBlackAndBlue,
};


export const BrowseCategories: React.FC<BrowseCategoriesProps> = (props: BrowseCategoriesProps) => {
    const template = useTemplate();
    const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

    return <TemplatedComponent {...props} />;
};
